import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, Outlet, useLocation } from 'react-router'
import { Spinner } from '#components/Spinner'
import { useIsAuthenticated } from '#features/User/userManager'

interface AuthenticatedRoutesProps {
  loginPath?: string
  pageHeader?: React.ReactNode
}

export const AuthenticatedRoutes: FC<AuthenticatedRoutesProps> = ({ loginPath = '/login', pageHeader }) => {
  const location = useLocation()
  const isAuthenticated = useIsAuthenticated()
  const { t } = useTranslation('shared')

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <>
      {pageHeader}

      {/* We render a spinner here, as Navigate is blocking while the login loader is working, this might be a problem with StrictMode */}
      <Spinner size="xl" subtitle={t('auth.login.redirect-to-login', 'Redirecting to login…')} />

      <Navigate
        to={{
          pathname: loginPath,
          search: `?from=${encodeURIComponent(location.pathname + location.search)}`,
        }}
        state={{ time: Date.now() }}
        replace
      />
    </>
  )
}
